module.exports = __webpack_public_path__ + "img/5.6c40a8ba.jpg";